<script>
export const group = 'Full'
</script>

<script setup>
import { colors } from '../../../tailwindTheme.config.js'
import AnimatedBackground from '../../AnimatedBackground.vue'
import ToFullTopLeft from './transitions/energetic_frequencies/ToFullTopLeft.vue'
import CharacterEnlarge from './text_animations/CharacterEnlarge.vue'
import TextSlideUp from './text_animations/TextSlideUp.vue'
import EFLoopAudioLevels02 from '../../../assets/animations/energetic_frequencies/loops/audio_levels_02.json'
import AnimatedSkewedEllipsMask from './shared/AnimatedSkewedEllipsMask.vue'
const gsapTimeline = useGsapTimeline()

defineProps({
  item: Object,
})

const schemes = [
  // { backgroundColor: colors.q.cr.red.primary, color: colors.q.cr.red.darker },
  { backgroundColor: '#fff', color: colors.q.cr.gray.lighter },
]

// This is a temporary solution to prevent the same color scheme from being used twice in a row.
// A more proper background color scheme selection (including logo color picking) should be implemented in the future.
const schemeIndex = ((window.lastUsedSchemeIndex ?? 1) + 1) % schemes.length
window.lastUsedSchemeIndex = schemeIndex

const scheme = schemes[schemeIndex]

const timelineSuperTitle = ref(null)
const timelineTitle = ref(null)
const timelineTitleOut = ref(null)
const timelineImage = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'Headline' }).add(timelineSuperTitle, '.7').add(timelineTitle, '.7').add(timelineImage, '.7')
})

const { onDisappear } = useDisappearable()
onDisappear(() => {
  timelineSuperTitle.value?.reverse()
  timelineImage.value?.reverse()

  return gsapTimeline({ name: 'Headline' }).add(timelineTitleOut.value()).add(timelineImage, '<').add(timelineSuperTitle, '<.5')
})
</script>

<template>
  <ToFullTopLeft>
    <AnimatedBackground :lottie="EFLoopAudioLevels02" :backgroundColor="scheme.backgroundColor" :color="scheme.color" :scale="3" :position="{ x: -968, y: 898 }">
      <div class="h-full flex flex-col justify-center px-32">
        <div>
          <AnimatedSkewedEllipsMask v-if="item.properties.image" class="size-96 mb-4" @timeline="timelineImage = $event">
            <img :src="item.properties.image" class="object-cover h-full w-full" />
          </AnimatedSkewedEllipsMask>
          <CharacterEnlarge
            v-if="item.properties.superTitle"
            :text="item.properties.superTitle"
            class="text-q-cr-red-primary text-[14rem] font-bold leading-none -mb-2"
            @timeline="timelineSuperTitle = $event"
          />
          <TextSlideUp :text="item.properties.title" class="text-q-cr-gray-darker text-[8rem] font-bold leading-none" @timeline="timelineTitle = $event" @timelineOut="timelineTitleOut = $event" />
        </div>
      </div>
    </AnimatedBackground>
  </ToFullTopLeft>
</template>
